export default class ClubClientSystemLink {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clientSystemLink = new ClubClientSystemLink();

        clientSystemLink.id = data.id;
        clientSystemLink.deleted = false;
        clientSystemLink.label = data.label;
        clientSystemLink.url = data.url;
        clientSystemLink.position = data.position;
        clientSystemLink.icon = data.icon;
        clientSystemLink.iconImageFile = data.iconImageFile;
        clientSystemLink.contractTypes = data.contractTypes ?? [];
        clientSystemLink.departments = data.departments ?? [];
        clientSystemLink.departmentObjects = null;
        clientSystemLink.authenticationTokenType = data.authenticationTokenType;

        return clientSystemLink;
    }

    constructor() {
        this.id = null;
        this.deleted = false;
        this.label = '';
        this.url = '';
        this.position = null;
        this.icon = null;
        this.iconImageFile = null;
        this.contractTypes = [];
        this.departments = [];
        this.departmentObjects = null;
        this.error = null;
    }

    serialize() {
        return {
            id:  this.id,
            label:  this.label,
            position: this.position,
            url:  this.url,
            icon:  this.icon,
            iconImageFile:  this.iconImageFile,
            contractTypes:  this.contractTypes.length > 0 ? this.contractTypes : null,
            departments:  this.departments.length > 0 ? this.departments : null,
        };
    }
}
